import React, {useState} from 'react';
import style from './TooltipStyle.module.scss';
import cn from 'classnames';

import CustomTooltip from 'components/common/CustomTooltip';

const useTooltip = (text, className, params = {}) => {
    const [displayed, setDisplayed] = useState(false);
    const hoverFunctions = {
        onMouseEnter: () => setDisplayed(true),
        onMouseLeave: () => setDisplayed(false),
    };

    const tooltip = (
        <div className={cn(style.tooltipContainer, params.containerClassName)}>
            <CustomTooltip text={text} className={className} displayed={displayed} params={params} />
        </div>
    );
    return {tooltip, hoverFunctions};
};

export default useTooltip;
